import React, { useEffect, useRef } from "react";

const HUBSPOT_EMBED_URL =
  "https://meetings-na2.hubspot.com/milad-ghods?embed=true";
const HUBSPOT_SCRIPT_URL =
  "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";

export default function BookDemoModal({ onClose }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const existing = document.querySelector(
      `script[src="${HUBSPOT_SCRIPT_URL}"]`
    );
    if (!existing) {
      const script = document.createElement("script");
      script.src = HUBSPOT_SCRIPT_URL;
      script.async = true;
      document.body.appendChild(script);
    } else {
      if (window.hbspt?.meetings?.create) {
        window.hbspt.meetings.create(
          containerRef.current.querySelector(".meetings-iframe-container")
        );
      }
    }
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />

      {/* Modal — bounded card on every screen size so users can clearly see
          the backdrop and the close (X) button in the corner. Internal
          content scrolls so the HubSpot "Schedule" submit is reachable. */}
      <div className="relative w-full max-w-3xl max-h-[92dvh] sm:max-h-[88dvh] bg-white rounded-2xl border border-gray-200 shadow-2xl overflow-hidden flex flex-col">
        {/* Header — stays put while body scrolls; X is always visible */}
        <div className="flex items-center justify-between px-5 sm:px-6 py-3.5 sm:py-4 border-b border-gray-200 flex-shrink-0">
          <div className="min-w-0">
            <h2 className="text-base sm:text-lg font-bold text-gray-900 truncate">
              Book a Demo
            </h2>
            <p className="text-xs sm:text-sm text-gray-500 truncate">
              Pick a time that works for you
            </p>
          </div>
          <button
            onClick={onClose}
            className="w-9 h-9 sm:w-8 sm:h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors flex-shrink-0 ml-3"
            aria-label="Close"
          >
            <svg
              className="w-4 h-4 text-gray-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* HubSpot embed — scrolls internally so the Schedule button at the
            bottom of the booking form is reachable on every device */}
        <div
          ref={containerRef}
          className="flex-1 min-h-0 overflow-y-auto overscroll-contain p-4 sm:p-6"
          style={{ WebkitOverflowScrolling: "touch" }}
        >
          <div
            className="meetings-iframe-container"
            data-src={HUBSPOT_EMBED_URL}
          />
        </div>
      </div>
    </div>
  );
}
